import i18next from "i18next";

export const PerformancePlanColumns = [
    {
        headerName: 'name',
        field: 'name',
        filter: true,
        width: 280
    },
    {
        headerName: 'description',
        field: 'description',
        filter: true,
        width: 320
    },
    {
        headerName: 'performance.evaluation_period',
        field: 'evaluationPeriodType',
        width: 190,
        valueFormatter: (params) => params.value ? i18next.t(`performance.period.${params.value}`) : ''
    },
    {
        headerName: 'performance.levels',
        field: 'levels',
        width: 130,
        valueFormatter: (params) => Array.isArray(params.value) ? params.value.length : 0
    },
    {
        headerName: 'status',
        field: 'status',
        type: 'trans',
        width: 130
    }
];
